<template>
  <div>
    <!-- <div class="text-xs-center mt-4 mb-3" v-if="campaignLoading">
      <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
    </div>
    <div v-else class="mb-2" style="display: flex; justify-content: end; flex-wrap: wrap">
      <v-btn
        v-for="(item, index) in campaignList"
        @click="chooseCampaign(item)"
        :outline="selectCampaign.name != item.name"
        :color="selectCampaign.name == item.name ? 'primary' : 'grey'"
        :key="`campaign-${index}`"
        >{{ item.name }}</v-btn
      >
    </div> -->
    <v-layout row wrap justify-end>
      <v-btn :loading="exportloading" @click="exportxlsx" color="grey" outline>
        <em class="fas fa-file-export" />
        &nbsp;Export&nbsp;
      </v-btn>
    </v-layout>
    <div class="mb-2">
      <date-filter
        @changeDate="onChangeDate"
        :defaultFilter="'last_7_days'"
        v-model="selectedDate"
      ></date-filter>
    </div>
    <!-- <div class="mb-2" style="display: flex; flex-wrap: nowrap; overflow: auto">
      <v-btn
        small
        :outline="selectStatus != ''"
        :color="selectStatus == '' ? 'primary' : 'grey'"
        @click="selectStatus = ''"
        style="width: 100px"
        >ทั้งหมด</v-btn
      >
      <v-btn
        small
        :outline="selectStatus != 'จัดส่งแล้ว'"
        :color="selectStatus == 'จัดส่งแล้ว' ? 'primary' : 'grey'"
        @click="selectStatus = 'จัดส่งแล้ว'"
        style="width: 100px"
        >จัดส่งแล้ว</v-btn
      >
      <v-btn small outline color="grey" @click="selectStatus = ''" style="width: 100px"
        >ยกเลิก</v-btn
      >
    </div> -->
    <v-layout row wrap>
      <v-flex xs12 sm4 class="form-control pa-1">
        <div class="form-inline form-control">
          <input v-model="filter.search" class="form-control" placeholder="ค้นหา" type="text" />
        </div>
      </v-flex>
      <v-flex xs12 sm4 class="form-control pa-1">
        <div class="form-inline form-control">
          <v-btn color="primary" @click="getData">ค้นหา</v-btn>
        </div>
      </v-flex>
      <!-- <v-flex xs12 sm4 class="form-control pa-1">
        <div class="form-inline form-control">
          <multiselect
            v-model="filter.name"
            :options="[]"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            placeholder="สถานะ"
          ></multiselect>
        </div>
      </v-flex> -->
      <!-- <v-flex xs12 sm4 class="form-control pa-1">
        <div class="form-inline form-control">
          <multiselect
            v-model="filter.name"
            :options="[]"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            placeholder="Role"
          ></multiselect>
        </div>
      </v-flex> -->
    </v-layout>

    <template v-if="selectCampaign && selectCampaign.type == 'lucky_draw'">
      <multiselect
        v-model="receiptStatus"
        :options="['ทั้งหมด', 'รอลูกค้ากรอกข้อมูลกลับ', 'กรอกข้อมูลเรียบร้อยแล้ว', 'อนุมัติแล้ว']"
        :searchable="false"
        selectLabel
        selectedLabel
        deselect-label
        :multiple="false"
        :placeholder="'ดูตามสถานะการกรอกข้อมูล'"
        style="max-width: 300px"
        @select="onSelectReceiptStatus"
      ></multiselect>
    </template>
    <v-layout row wrap align-content-end justify-end>
      <v-pagination
        :total-visible="6"
        v-model="pageNumber"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
    </v-layout>
    <v-layout row wrap>
      <v-checkbox
        @change="onApproveAllInCurrentPage($event)"
        label="เลือกทั้งหมด"
        class="col-auto"
        style="width: max-content"
        color="primary"
      ></v-checkbox>
      <v-btn color="primary" :loading="approveLoading" @click="onApprove">Approve</v-btn>
      <v-btn color="primary" outline @click="onApproveAll" :loading="approveAllLoading"
        >Approve all</v-btn
      >
    </v-layout>
    <div class="text-xs-center mt-4 mb-5" v-if="loading">
      <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
    </div>
    <div v-else class="card-outline mb-5" v-for="(item, index) in items" :key="index">
      <v-layout class="px-3 mb-0" row wrap justify-space-between>
        <v-flex shrink>
          <v-checkbox
            :input-value="IsCheckAllOrder"
            @change="chooseOrder(item, $event)"
            :label="`Order No. ${item.id}`"
            class="col-auto"
            style="width: max-content"
            color="primary"
          ></v-checkbox>
        </v-flex>
        <v-flex shrink class="pl-3">
          <v-chip
            color="warning"
            v-if="!item.identity_image"
            small
            class="white--text mt-3"
            disabled
          >
            รอลูกค้ากรอกข้อมูลกลับ
          </v-chip>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn
            flat
            @click="
              selectedReward = item
              showHistory = true
            "
          >
            {{ item.adminid || 'ประวัติการอนุมัติ' }}
          </v-btn>
        </v-flex>
        <!-- <span style="margin-top: 20px">Assignee : -</span> -->
      </v-layout>
      <v-divider></v-divider>
      <v-layout row wrap class="mt-1">
        <v-flex xs7 sm8>
          <div class="pt-2" style="border-right: 1px solid #eee">
            <!-- <v-layout row justify-end class="text-gray"> {{ item.total_points }} </v-layout> -->
            <div class="pl-3">
              <v-layout v-for="p in item.productdetails" :key="p.id" row wrap>
                <v-flex xs4>
                  <v-img :src="p.photo"></v-img>
                </v-flex>
                <v-flex xs8 class="mt-2 pl-3">
                  <div>{{ p.name }}</div>
                  <template v-if="selectCampaign && selectCampaign.type != 'lucky_draw'">
                    <div class="text-cus">ใช้ {{ p.points / p.quantity }} แต้ม</div>
                    <div class="text-cus">จำนวนที่แลกทั้งหมด {{ p.quantity }} สิทธิ์</div>
                    <div class="text-cus">รวม {{ p.points }} แต้ม</div>
                  </template>
                </v-flex>
              </v-layout>
              <template v-if="selectCampaign && selectCampaign.type != 'lucky_draw'">
                <div class="mt-2">แต้มทั้งหมด {{ item.original_score || '-' }} แต้ม</div>
                <div class="mt-2">แต้มที่ใช้ทั้งหมด {{ item.total_points }} แต้ม</div>
                <div class="mt-2">
                  แต้มคงเหลือ
                  {{ item.original_score ? item.original_score - item.total_points : '-' }} แต้ม
                </div>
              </template>
            </div>
            <v-btn
              outline
              small
              color="primary"
              :disabled="!item.identity_image"
              @click="
                currentIdentity = item.identity_image
                showIdentity = true
              "
            >
              ภาพบัตรประชาชน
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs5 sm4>
          <div style="word-break: break-word" class="pa-2">
            <h6>
              {{ item.registration_data.firstName + ' ' + item.registration_data.lastName }} ({{
                item.linename
              }})
            </h6>
            <div class="mt-2">{{ item.first_name + ' ' + item.last_name }}</div>
            <div class="mt-2 text-gray">
              {{
                (item.address || '') +
                ' ' +
                (item.sub_district || '') +
                ' ' +
                (item.district || '') +
                ' ' +
                (item.province || '') +
                ' ' +
                (item.post_code || '') +
                (item.phone_number ? ' , เบอร์โทรศัพท์ ' + item.phone_number : '')
              }}
            </div>
            <div class="my-4">
              <div>สถานะ</div>
              <div class="primary--text">{{ item.shippoing_status || 'รอดำเนินการ' }}</div>
              <div class="mt-3">ป้ายกำกับ</div>
              <div class="primary--text">-</div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog v-model="showIdentity" scrollable max-width="500px">
      <v-card>
        <div class="text-xs-right">
          <v-btn
            small
            flat
            fab
            @click="
              currentIdentity = null
              showIdentity = false
            "
          >
            <v-icon> close </v-icon>
          </v-btn>
        </div>
        <v-card-text v-if="currentIdentity">
          <img style="width: 100%" :src="currentIdentity" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showHistory">
      <v-card>
        <v-card-title>
          <span class="title primary--text"> ประวัติการอนุมัติ </span>
          <v-spacer />
          <v-btn
            @click="
              showHistory = false
              selectedReward = null
            "
            icon
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <table>
            <thead>
              <tr>
                <th>ชื่อ Admin</th>
                <th>ทำรายการเมื่อ</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="selectedReward && selectedReward.approve_history.length > 0">
                <template v-for="(history, index) in selectedReward.approve_history">
                  <tr :key="index">
                    <td>{{ history.adminid }}</td>
                    <td>{{ history.timestamp }}</td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <td colspan="2" class="text-xs-center">No data</td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import MemberEdit from './MemberEdit.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import api from '@/api'
import SearchMember from './SearchMember.vue'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import MemberHistoryCoupon from './MemberHistoryCoupon.vue'
import XLSX from 'xlsx'

export default {
  components: {
    Multiselect,
    SearchMember,
    DatePickerWithoutButton,
    MemberEdit,
    exportxlsx,
    DateFilter,
    MemberHistoryCoupon
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },
    selectCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  data() {
    return {
      showHistory: false,
      selectedReward: null,
      showIdentity: false,
      currentIdentity: null,
      selectStatus: '',
      campaignList: [],
      item: [
        {
          orderid: '4242'
        }
      ],
      filter: {
        search: '',
        name: '',
        role: '',
        status: '',
        dateFrom: '',
        dateTo: ''
      },
      pageNumber: 1,
      loading: false,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      campaignLoading: false,
      limit: 10,
      offset: 0,
      items: [],
      total: 0,
      pagetmp: 1,
      rewardIds: [],
      approveLoading: false,
      approveAllLoading: false,
      IsCheckAllOrder: false,
      exportloading: false,
      receiptStatus: 'ทั้งหมด'
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onSelectReceiptStatus(option, id) {
      console.log(option, id)
      this.receiptStatus = option
      this.offset = 0
      this.getData()
    },
    exportxlsx() {
      this.$store.dispatch('loading')
      this.exportloading = true
      let data = {
        pageid: this.selectedBot.pageid,
        // campaign_id: this.selectCampaign ? this.selectCampaign.id : null,
        limit: 999,
        offset: 0,
        role:
          this.$store.state.privilege && this.$store.state.privilege.role
            ? this.$store.state.privilege.role
            : null,
        status:
          this.selectCampaign &&
          this.selectCampaign.type == 'lucky_draw' &&
          this.receiptStatus != 'ทั้งหมด'
            ? this.receiptStatus
            : null,
        campaign_id: this.selectCampaign ? this.selectCampaign.id : null
      }

      for (const key in this.filter) {
        if (this.filter[key]) {
          Object.assign(data, { [key]: this.filter[key] })
        }
      }

      api.EXPORT_TOAECOUPONGetRewardRequest(data, (err, response) => {
        this.exportloading = false
        this.$store.dispatch('loading')
        if (response.responsecode == 200) {
          let json = response.data

          let reward1 = []
          let reward2 = []

          json.forEach((e1) => {
            let data_count = {}
            e1.productdetails.forEach((e2) => {
              reward1.push({
                เลขที่ออเดอร์: e1.id,
                ชื่อลูกค้า: (e1.first_name || '') + ' ' + (e1.last_name || ''),
                สินค้าที่แลก: e2.name,
                จำนวนของรางวัลที่แลก: e2.quantity,
                รวมคะแนนที่แลก: e2.points,
                คะแนนคงเหลือ: e1.original_score ? e1.original_score - e1.total_points : '-',
                'Admin Approve': e1.adminid
              })
              if (!data_count[e2.name]) {
                data_count[e2.name] = e2.quantity
              } else {
                data_count[e2.name] = data_count[e2.name] + e2.quantity
              }
            })

            reward2.push({
              จำนวนคะแนนที่แลก: e1.original_score,
              รวมคะแนนที่แลก: e1.total_points,
              คะแนนคงเหลือ: e1.original_score ? e1.original_score - e1.total_points : '-',
              'Admin Approve': e1.adminid,
              ...data_count
            })
          })

          const wb = XLSX.utils.book_new()
          const dataWS = XLSX.utils.json_to_sheet(reward1)
          XLSX.utils.book_append_sheet(wb, dataWS, 'การแลกสินค้า')

          const dataWs2 = XLSX.utils.json_to_sheet(reward2)
          XLSX.utils.book_append_sheet(wb, dataWs2, 'การแลกสินค้า(2)')

          XLSX.writeFile(wb, 'exportedApproveReward' + '.xlsx')
        }
      })
    },
    onChangeDate() {
      this.filter = {
        name: '',
        phoneNumber: '',
        dateFrom: '',
        dateTo: ''
      }
      this.getData(false, false, 'date')
    },
    getEnabledCampagin() {
      this.campaignLoading = true
      let payload = {
        pageid: this.selectedBot.pageid,
        source: 'cms'
      }

      api.TOAECOUPONgetAllCampaign(payload, (err, result) => {
        if (result.responsecode == 200) {
          this.campaignLoading = false
          this.campaignList =
            result.data.length > 0 ? result.data.filter((f) => f.type == 'collect') : []
          if (this.campaignList && this.campaignList.length > 0) {
            this.selectCampaign = this.campaignList[0]
            this.getData()
          }
        }
      })
    },
    getData() {
      return new Promise((resolve) => {
        this.loading = true

        let data = {
          pageid: this.selectedBot.pageid,
          campaign_id: this.selectCampaign ? this.selectCampaign.id : null,
          start_date: this.selectedDate.start,
          end_date: this.selectedDate.end,
          limit: this.limit,
          offset: this.offset,
          role:
            this.$store.state.privilege && this.$store.state.privilege.role
              ? this.$store.state.privilege.role
              : null,
          status:
            this.selectCampaign &&
            this.selectCampaign.type == 'lucky_draw' &&
            this.receiptStatus != 'ทั้งหมด'
              ? this.receiptStatus
              : null
        }

        for (const key in this.filter) {
          if (this.filter[key]) {
            Object.assign(data, { [key]: this.filter[key] })
          }
        }

        api.TOAECOUPONGetRewardRequest(data, (err, response) => {
          resolve()
          this.loading = false
          if (response.responsecode == 200) {
            this.items = response.data
            this.total = response.total
          }
        })
      })
    },
    chooseCampaign(campaign) {
      this.selectCampaign = campaign
      this.offset = 0
      this.getData()
    },
    changePage(val) {
      if (this.pagetmp != val) {
        this.pagetmp = val
        this.offset = this.pageNumber * this.limit - this.limit
        if (this.pageNumber != 1) {
          this.offset + 1
        }
        this.getData()
      }
    },
    onApproveAll() {
      this.approveAllLoading = true
      this.$store.dispatch('loading')
      let payload = {
        pageid: this.selectedBot.pageid,
        campaign_id: this.selectCampaign ? this.selectCampaign.id : null
      }

      api.TOAECOUPONApproveAllRewardRequest(payload, (err, result) => {
        this.$store.dispatch('loading')
        this.approveAllLoading = false
        this.rewardIds = []
        if (result.responsecode == 200) {
          this.getData()
        }
      })
    },
    onApprove() {
      if (this.rewardIds.length == 0) {
        return
      }

      this.$store.dispatch('loading')

      this.approveLoading = true
      let payload = {
        pageid: this.selectedBot.pageid,
        rewardIds: this.rewardIds,
        campaign_id: this.selectCampaign ? this.selectCampaign.id : null
      }

      api.TOAECOUPONApproveRewardRequest(payload, (err, result) => {
        this.approveLoading = false
        this.$store.commit('CLEAR_LOADING')
        this.rewardIds = []
        if (result.responsecode == 200) {
          this.getData()
        }
      })
    },
    chooseOrder(item, value) {
      const index = this.rewardIds.find((f) => f.id == item.id)
      if (index != -1) {
        if (value) {
          this.rewardIds.push(item.id)
        } else {
          this.rewardIds.splice(index, 1)
        }
      } else {
        this.rewardIds.push(item.id)
      }
    },
    onApproveAllInCurrentPage(value) {
      if (value) {
        this.rewardIds = this.items.map((m) => m.id)
        this.IsCheckAllOrder = true
      } else {
        this.rewardIds = []
        this.IsCheckAllOrder = false
      }
    }
  }
}
</script>

<style lang="scss">
@import 'photoviewer/dist/photoviewer.css';
.isprimay {
  background-color: #ff706b !important;
  color: white !important;
}
.text-gray {
  color: #969595;
}
.text-cus {
  color: #ff706b !important;
}
.card-outline {
  border: 1px solid #ff706b;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/Approvereward.vue